<template>
  <div class="out_box">
    <div class="page_head mgt20">
      <div class="title mgl20">Agent profile</div>
      <div class="btn_addagent mgr20" @click="showAdd()">
        <img
          class="btn_addagent_icon"
          src="../../../assets/img/icon_add.png"
          alt=""
          srcset=""
        />
        <div class="mgl4">Add account</div>
      </div>
    </div>

    <div class="flex_box">
      <div class="gpitem" v-for="(item, i) in tableData" :key="i">
        <agent-item :detail="item" @edit="showEdit(item)" @delete="loadList" />
      </div>
      <div
        class="gpitem"
        v-for="item in row - (tableData.length % row)"
        v-if="tableData.length % row > 0"
        :key="item"
      ></div>
    </div>

    <agent-new-edit ref="agentNewEdit" @edit="loadList" />
  </div>
</template>

<script>
import agentItem from '@/views/home/agent/agentItem.vue'
import agentNewEdit from '@/views/home/agent/agentNewEdit.vue'
import { agentList } from '@/api/agent/agent'

export default {
  components: {
    agentItem,
    agentNewEdit
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalElements: 0,
      totalPage: 0,
      tableData: [],
      row: 3
    }
  },
  filters: {},
  created() {},
  mounted() {
    this.loadList()
  },
  methods: {
    loadList() {
      const params = {
        number: this.currentPage,
        size: this.pageSize
      }
      agentList(params).then((res) => {
        this.tableData = res.data.results
        this.totalElements = res.data.totalElements
        this.totalPage = res.data.totalPage
      })
    },
    showAdd() {
      this.$refs.agentNewEdit.show()
    },
    showEdit(data) {
      this.$refs.agentNewEdit.show(data)
    }
  }
}
</script>

<style scoped lang="scss">
.page_head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #000000;
    font-style: normal;
  }

  .btn_addagent {
    width: 151px;
    height: 32px;
    background: #200e32;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 17px;
    font-style: normal;

    .btn_addagent_icon {
      width: 10px;
      height: 10px;
    }
  }
}

.flex_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px 50px;

  .gpitem {
    flex: 33.3333333333%;
  }
}
</style>
